@if (step() === 'form') {
  <h2 mat-dialog-title>Supportcode aanmaken</h2>

  <mat-dialog-content>
    <p class="text-sm text-gray-500 mb-6">
      Selecteer de gewenste unit, rollen en sessieduur voor de supportmedewerker.
    </p>

    <form [formGroup]="addForm" (ngSubmit)="handleAdd()" class="space-y-6">
      <!-- Unit Selection -->
      <div>
        <label class="block font-medium text-gray-900 text-sm mb-1" for="dialog-unit">
          Welke unit heeft support nodig?
        </label>
        <p class="text-sm text-gray-500 mb-2">
          Selecteer de unit waar support nodig is.
        </p>
        <mat-form-field class="w-full">
          <mat-select formControlName="unitId" id="dialog-unit" placeholder="Selecteer een unit...">
            @for (unit of data.units; track unit._id) {
              <mat-option [value]="unit._id">{{ unit.name }}</mat-option>
            }
          </mat-select>
          @if (addForm.controls.unitId.hasError('required')) {
            <mat-error>Selecteer een unit</mat-error>
          }
        </mat-form-field>
      </div>

      <hr class="border-gray-100" />

      <!-- Role Selection -->
      <div>
        <label class="block font-medium text-gray-900 text-sm mb-1" for="dialog-roles">
          Welke rol heeft support nodig?
        </label>
        <p class="text-sm text-gray-500 mb-2">
          Deze rollen zijn beschikbaar in de geselecteerde unit.
        </p>
        <mat-form-field class="w-full">
          <mat-select formControlName="userRoleIds" id="dialog-roles" multiple placeholder="Selecteer een rol...">
            @for (role of data.roles; track role._id) {
              <mat-option [value]="role._id">{{ role.label }}</mat-option>
            }
          </mat-select>
          @if (addForm.controls.userRoleIds.hasError('required')) {
            <mat-error>Kies minimaal één rol</mat-error>
          }
        </mat-form-field>
      </div>

      <hr class="border-gray-100" />

      <!-- Duration Selection -->
      <div>
        <label class="block font-medium text-gray-900 text-sm mb-1">
          Hoe lang heb je support nodig?
        </label>
        <p class="text-sm text-gray-500 mb-3">
          Kies de verwachte sessieduur.
        </p>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <button
            type="button"
            (click)="setDurationType('30m')"
            [class]="
              addForm.controls.durationType.value === '30m'
                ? 'border-2 border-blue-600 bg-blue-50/50 text-blue-700 font-medium py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
                : 'border-2 border-gray-200 bg-white hover:bg-gray-50 text-gray-700 py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
            "
          >
            30 min
          </button>
          <button
            type="button"
            (click)="setDurationType('1h')"
            [class]="
              addForm.controls.durationType.value === '1h'
                ? 'border-2 border-blue-600 bg-blue-50/50 text-blue-700 font-medium py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
                : 'border-2 border-gray-200 bg-white hover:bg-gray-50 text-gray-700 py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
            "
          >
            1 uur
          </button>
          <button
            type="button"
            (click)="setDurationType('2h')"
            [class]="
              addForm.controls.durationType.value === '2h'
                ? 'border-2 border-blue-600 bg-blue-50/50 text-blue-700 font-medium py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
                : 'border-2 border-gray-200 bg-white hover:bg-gray-50 text-gray-700 py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
            "
          >
            2 uur
          </button>
          <button
            type="button"
            (click)="setDurationType('custom')"
            [class]="
              addForm.controls.durationType.value === 'custom'
                ? 'border-2 border-blue-600 bg-blue-50/50 text-blue-700 font-medium py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
                : 'border-2 border-gray-200 bg-white hover:bg-gray-50 text-gray-700 py-2.5 px-3 rounded-lg text-center text-sm transition-all cursor-pointer'
            "
          >
            Aangepast
          </button>
        </div>

        @if (addForm.controls.durationType.value === 'custom') {
          <div class="mt-4 p-4 bg-gray-100 border border-gray-200 rounded-lg w-full">
            <label
              class="block font-medium text-gray-900 text-sm mb-1"
              for="dialog-custom-duration-select"
            >
              Aangepaste sessieduur
            </label>
            <p class="text-xs text-gray-500 mb-3">
              Kies een specifieke tijdsduur in stappen van 15 minuten (min. 15 min, max. 8 uur).
            </p>
            <mat-form-field class="w-full [&_.mat-mdc-text-field-wrapper]:bg-white" subscriptSizing="dynamic">
              <mat-select
                id="dialog-custom-duration-select"
                formControlName="customDurationMinutes"
                placeholder="Selecteer tijdsduur..."
              >
                @for (option of customDurationOptions; track option.minutes) {
                  <mat-option [value]="option.minutes">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        <p class="text-xs text-gray-500 mt-3">
          Ondersteuning vervalt automatisch na de gekozen duur.
        </p>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="closeDialog()">
      Annuleren
    </button>
    <button
      mat-flat-button
      type="button"
      (click)="handleAdd()"
      [disabled]="addForm.invalid || submitting()"
    >
      Code aanmaken
    </button>
  </mat-dialog-actions>
} @else {
  <h2 mat-dialog-title>Code aangemaakt</h2>

  <mat-dialog-content>
    <div class="bg-blue-50/70 border border-blue-200 rounded-lg p-4 mb-6">
      <p class="text-sm text-gray-700 leading-relaxed">
        Geef deze code telefonisch of per e-mail door aan support. Hij wordt
        hierna niet meer getoond — sluit je dit venster, dan is de code weg
        en maak je een nieuwe aan.
      </p>
    </div>

    <div class="flex flex-col items-center justify-center p-6 bg-gray-50 border border-gray-200 rounded-xl mb-6">
      <span class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2">Eenmalige supportcode</span>
      <div class="flex items-center justify-center gap-3">
        <span class="text-3xl font-mono font-bold tracking-widest text-gray-900 select-all">
          {{ generatedCode() }}
        </span>
        <button
          mat-icon-button
          type="button"
          matTooltip="Kopiëren naar klembord"
          (click)="copyGeneratedCode()"
          class="text-gray-600 hover:text-blue-600"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    @if (generatedCodeRecord()) {
      <div class="flex flex-wrap items-center justify-around gap-4 text-sm text-gray-700 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200">
        <div>
          <span class="font-medium text-gray-900">Sessieduur:</span>
          {{ getDurationText(generatedCodeRecord()?.createdAt, generatedCodeRecord()?.expiresAt) }}
        </div>
        <div class="h-4 w-px bg-gray-300 hidden sm:block"></div>
        <div>
          <span class="font-medium text-gray-900">Geldig tot:</span>
          {{ generatedCodeRecord()?.expiresAt | date: 'dd MMM yyyy HH:mm' }}
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button type="button" (click)="closeDialog()">
      Sluiten
    </button>
  </mat-dialog-actions>
}


